import { AppRootStateType } from 'state/store';

export const newcomersSelect = (state: AppRootStateType) => state.statistics.newcomers;
export const activeUsersSelect = (state: AppRootStateType) => state.statistics.active;
export const blockedUsersSelect = (state: AppRootStateType) => state.statistics.blocked;
export const financesStatisticsSelect = (state: AppRootStateType) =>
  state.statistics.finances;
